import { ICON_NAMES } from 'foundations-assets/icons/iconNames';
const ICON_NAME_SET = new Set(ICON_NAMES);
export const resolveAgentIconName = iconName => {
  if (!iconName) {
    return undefined;
  }
  const normalized = iconName.endsWith('Icon') ? iconName.slice(0, -4) : iconName;
  if (!ICON_NAME_SET.has(normalized)) {
    return undefined;
  }
  return normalized;
};